import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCategories as getCategories,
  getCategoriesSelect as selectFinalCategory,
  searchCategories as searchCategoriesFN,
  createProducts,
} from "../../helpers/backend_helper";

let sampleProductDTO:any = {
      
  "nameEn": "string",
  "nameUr": "string",
  "categoryId": "string",
  "productImages": [
    {
      "url": "string",
      "metaData": {
        "height": 0,
        "width": 0,
        "fileType": "string",
        "fileFormat": "string",
        "name": "string",
        "duration": 0
      }
    }
  ],
  "promotionImage": {
    "url": "string",
    "metaData": {
      "height": 0,
      "width": 0,
      "fileType": "string",
      "fileFormat": "string",
      "name": "string",
      "duration": 0
    }
  },
  "promotionWhiteImageBg": {
    "url": "string",
    "metaData": {
      "height": 0,
      "width": 0,
      "fileType": "string",
      "fileFormat": "string",
      "name": "string",
      "duration": 0
    }
  },
  "productVideo": {
    "url": "string",
    "metaData": {
      "height": 0,
      "width": 0,
      "fileType": "string",
      "fileFormat": "string",
      "name": "string",
      "duration": 0
    }
  },
  "description": {
    "mainDescription": "string",
    "productDescription": "string",
    "highlights": "string",
    "whatIsInTheBox": "string"
  },
  "warranty": {
    "type": "string",
    "period": {
      "value": 0,
      "unit": "string"
    },
    "policy": "string"
  },
  "containDangerousGoods": true,
  "isDeliveryByBuyPass": true,
  "package": {
    "isIndividual": true,
    "weight": {
      "value": 0,
      "unit": "string"
    },
    "dimensions": {
      "width": 0,
      "height": 0,
      "length": 0,
      "unit": "string"
    }
  },
  "sellerBrandId": "string",
  "productSpecifications": [
    {
      "key": "string",
      "value": "string"
    }
  ],
  "variants": [
    {
      "type": "string",
      "subType": "string",
      "values": [
        {
          "name": "string",
          "images": [
            {
              "url": "string",
              "metaData": {
                "height": 0,
                "width": 0,
                "fileType": "string",
                "fileFormat": "string",
                "name": "string",
                "duration": 0
              }
            }
          ]
        }
      ]
    }
  ],
  "subProduct": [
    {
      "price": 0,
      "variants": [
        {
          "type": "string",
          "subType": "string",
          "value": {
            "name": "string",
            "images": [
              {
                "url": "string",
                "metaData": {
                  "height": 0,
                  "width": 0,
                  "fileType": "string",
                  "fileFormat": "string",
                  "name": "string",
                  "duration": 0
                }
              }
            ]
          }
        }
      ],
      "specialPrice": {
        "amount": 0,
        "startDate": "2024-11-13T18:59:24.300Z",
        "endDate": "2024-11-13T18:59:24.300Z"
      },
      "stock": 0,
      "freeItems": "string",
      "isAvailable": true,
      "extraFields": [
        {
          "key": "string",
          "value": "string"
        }
      ],
      "productPackage": {
        "isIndividual": true,
        "weight": {
          "value": 0,
          "unit": "string"
        },
        "dimensions": {
          "width": 0,
          "height": 0,
          "length": 0,
          "unit": "string"
        }
      },
      "sku": "string"
    }
  ],
  "contentScore": {
    "score": 0,
    "reasons": [
      "string"
    ],
    "link": "string",
    "text": "string",
    "type": "string",
    "indicators": {
      "name": "string"
    }
  }

} 


export const getCategoriesFunc = createAsyncThunk("category/getAllCategories", async (id: any = '') => {
  try {
    const response = await getCategories(id);
    return response.data;

  } catch (error) {
    return [];
  }
});

export const getCategoriesSelectFunc = createAsyncThunk("category/getCategoriesSelectFunc", async (categoryId: string) => {
  try {
    const response = await selectFinalCategory(categoryId);
    return response.data;

  } catch (error) {
    return [];
  }
});

export const searchCategoriesFunc = createAsyncThunk("category/searchCategoriesFunc", async (keyword: string) => {
  try {
    const response = await searchCategoriesFN(keyword);
    return response.data;
  } catch (error) {
    return [];
  }
});

export const clearSearchCategoriesFunc = createAsyncThunk("category/clearSearchCategoriesFunc", () => {
  return [];
});


export const addProductFromJSON = createAsyncThunk("category/addProductFromJSON", async(formData:any) => {

  try {
    let data = JSON.parse(JSON.stringify(formData));
    let jsonToSend = JSON.parse(JSON.stringify(sampleProductDTO)); 
    // 
    jsonToSend.categoryId = data.categoryId
    jsonToSend.nameEn = data.nameEn;
    jsonToSend.nameUr = data.nameUr;
    jsonToSend.description = {
      "mainDescription": data.description,
      "productDescription": data.enDescription,
      "highlights": data.shortDescription,
      "whatIsInTheBox": data.packageContent
    };
    jsonToSend.subProduct = data.subProducts;
    jsonToSend.variants = data.variants.map((x: any)=> {
      delete x.options;
      x.values = x.values.map((y:any)=> {
        return {
          name: y.label,
          images: [],
        }
      })
      return x;
    });
    jsonToSend.warranty = {
      "type": data.warrantyType,
      "period": {
        "value": 0,
        "unit": data.warrantyPeriod
      },
      "policy": data.warrantyPolicy
    };
    jsonToSend.package= {
      "isIndividual": true,
      "weight": {
        "value": parseInt(data.packageWeight),
        "unit": data.packageWeightUnit
      },
      "dimensions": {
        "width": data.logisticsSizePackageWidth,
        "height": data.logisticsSizePackageHeight,
        "length": data.logisticsSizePackageLength,
        "unit": "cm"
      }
    };
    jsonToSend.containDangerousGoods = data.radioDangerousGoods;
    jsonToSend.promotionImage = data.promotionImage;
    jsonToSend.promotionWhiteImageBg = data.promotionWhiteImageBg;
    jsonToSend.productImages = data.productImages;
    const response = await createProducts(jsonToSend);
    return response;
  } catch (error) {
    return { isSuccess: false, message: "Please! fill out the complete form"};
  }
});

export const clearSubmittedProductFunc = createAsyncThunk("category/clearSubmittedProductFunc", () => {
  return [];
});
